import React from 'react';
import Modal from '../../../../Components/Modal';
import Section, { Sections } from '../../../../Components/Containers/Section';
import Title from '../../../../Components/Formatting/Customer/Title';
import Services from '../../../../Components/Formatting/Services';
import Button from '../../../../Components/Button/Button';
import { classNames, getEntityLink } from '../../../../Services/helpers';
import { statuses, useScheduleMany } from '../../../../Data/Jobs';
import Form, { Actions, EventTriggers, User } from '../../../../Components/Form';
import { eventTriggers } from '../../../../Data/Misc';
import { getDateStr } from '../../../../Components/Formatting/DateTime';
import { Badge } from '@/Components/Primitives';

const Schedule = ({isOpen, setIsOpen, date, rounds, jobs, onScheduled, assignTo}) => {
    return <Modal isOpen={isOpen} setIsOpen={setIsOpen} title={'Schedule for '+getDateStr(date)} dismissible>
        {isOpen && <Inner {...{date, rounds, jobs, onScheduled, assignTo}} />}
    </Modal>
}

const Inner = ({date, rounds, jobs, onScheduled, assignTo}) => {
    const schedule = useScheduleMany();

    const doSchedule = (data) => {
        return schedule({
            actionSource: 'Suggested',
            ...data,
            date: date,
            ids: [
                ...jobs.map(job => ({jobId: job.id, customerId: job.customerId})),
                ...rounds.flatMap(round => round.jobs.map(job => ({jobId: job.id, customerId: job.customerId})))
            ]
        })
    }

    return <>
        <Sections spacing="mb-5">
            {rounds.map(round => {
                return <Section key={round.id} title={round.name}>
                    <JobsList jobs={round.jobs} />
                </Section>
            })}
            {jobs.length > 0 && <Section title="Jobs without rounds">
                <JobsList jobs={jobs} />
            </Section>}
        </Sections>
        <Form data={{assignedTo: assignTo === 'unassigned' ? null : assignTo}} onSubmit={doSchedule} afterSubmit={onScheduled} closeModalOnSubmit>
            <EventTriggers triggers={[eventTriggers.SEND_NOTIFICATIONS]} />
            <User name="assignedTo" label="Assign to" />
            <Actions submit={{label: 'Schedule all'}} />
        </Form>
    </>
}

const JobsList = ({jobs}) => {
    return <ul className="flex flex-col divide-y px-3 rounded-xl border max-h-[50vh] overflow-y-auto">
        {jobs.map(job => {
            return <li key={job.id} className="flex flex-row py-2">
                <div className="flex flex-col grow">
                    <Title customerId={job.customerId} className="font-bold" />
                    <span>{job.title ?? <Services services={job.services} />}</span>
                    <span>
                        <Badge className={classNames(statuses[job.status].bgColor, statuses[job.status].contrastTextColor)}
                            title={job.status}
                        />
                    </span>
                </div>
                <div className="shrink-0">
                    <Button theme="light" icon="User" link={getEntityLink('Customers/Customer', job.customerId)} />
                </div>
            </li>
        })}
    </ul>
}

export default Schedule;
